import React, { ReactNode } from 'react';

export interface ListItemProps {
    underline?: boolean;
    children?: ReactNode;
}

export const ListItem: React.FC<ListItemProps> = (props) => {
    return (
        <li className={'list-item' + (props.underline ? ' underline' : '')}>
            {props.children}
        </li>
    );
};

export interface ListProps {
    title?: string;
    content?: Record<string, ReactNode> | [string, ReactNode][];
    children?: ReactNode;
    underline?: boolean;
}

export const List: React.FC<ListProps> = (props) => {
    let list;
    if (props.content) {
        list = Array.isArray(props.content) ? props.content : Object.entries(props.content);
    } else {
        list = props.children;
    }

    return (
        <div className="styled-list">
            {props.title && <h3>{props.title}</h3>}
            <ul>
                {Array.isArray(list)
                    ? list.map((e, i) => (
                        <ListItem key={i} underline={props.underline}>
                            {Array.isArray(e) ? (
                                <>
                                    <div>{e[0]}</div>
                                    <span>{e[1]}</span>
                                </>
                            ) : (
                                e
                            )}
                        </ListItem>
                    ))
                    : list}
            </ul>
        </div>
    );
};
